import React from 'react';
import styled from 'styled-components';

type ErrorProps = {
  code: number;
  title: string;
  children: JSX.Element;
};

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;  
  justify-content: center;
  width: 100%;

  h1 {
    color: rgba(81,40,226,1);
    font-size: 6.25rem;
    font-weight: 900;
    line-height: 8.125rem;
  }

  h2 {
    font-size: 2rem;
    font-weight: 300;
    line-height: 5rem;
  }
`;

export const Error: React.FunctionComponent<ErrorProps> = ({
  code,
  title,
  children,
}: ErrorProps) => {
  return (
    <Container>
      <h1>{code}</h1>
      <h2>{title}</h2>
      {children}
    </Container>
  );
};
